import React from 'react'
import styles from './CustomContainerLoader.module.css'

const CustomContainerLoader = () => {
    return (
        <div className={styles['loader_container']} role="status" aria-live="polite" aria-label="Loading">
            <span className={styles['sm_spinner']} />
        </div>
    )
}

export default CustomContainerLoader
